import colors from "./color"

export const textXS = (fontWeight: number = 500, color: string = colors.neutral.N300) => ({
    fontFamily: 'Inter',
    fontWeight,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0%',
    color,
})

export const textSM = (fontWeight: number = 500, color: string | 'aiGradient' = colors.neutral.N400) => {
    const baseStyles = {
        fontFamily: 'Inter',
        fontWeight,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0%',
        overflowWrap: "break-word" as const,
        wordBreak: "break-word" as const,
    };

    if (color === 'aiGradient') {
        return {
            ...baseStyles,
            background: colors.aiLinearGradient,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            color: 'transparent',
        } as const;
    }

    return {
        ...baseStyles,
        color,
    };
}

export const textBase = (fontWeight: number = 500, color: string = colors.neutral.N700) => ({
    fontFamily: 'Inter',
    fontWeight,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0%',
    color,
})

export const headingH5 = (fontWeight: number = 600, color: string = colors.neutral.N700) => ({
    fontFamily: 'Inter',
    fontWeight,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '0%',
    color,
})

export const headingH6 = (fontWeight: number = 600, color: string = colors.neutral.N700) => ({
    fontFamily: 'Inter',
    fontWeight,
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0%',
    color,
})